import React, { FC } from "react";

import { ContentUnavailable } from "@/components/ContentUnavailable";

import OfferMessageNotReceivedImage from "@assets/image/offer_message_not_received.png";

export const AGENT_NOT_FOUND_TITLE = "このプランナーは現在表示できません";
export const AGENT_NOT_FOUND_DESCRIPTION =
  "プランナーの提携終了や退会などにより、\n表示できなくなった可能性があります。";
export const AGENT_NOT_FOUND_BACK_LABEL = "プランナー一覧へ戻る";

interface AgentNotFoundProps {
  // プランナー一覧への導線。PC 右ペインのように一覧が同時に見えている場合は省略する
  onBack?: () => void;
}

/**
 * プランナー詳細 API が 404（提携終了・退会したプランナー、存在しない ID）のときの案内。
 * API 側は提携終了と不存在を区別しないため、理由を断定せず「表示できない」として案内する。
 * 表示部分を ContentUnavailable で共有する。
 */
export const AgentNotFound: FC<AgentNotFoundProps> = ({ onBack }) => (
  <ContentUnavailable
    onBack={onBack}
    imageUrl={OfferMessageNotReceivedImage}
    testId="agent-not-found"
    title={AGENT_NOT_FOUND_TITLE}
    description={AGENT_NOT_FOUND_DESCRIPTION}
    backLabel={AGENT_NOT_FOUND_BACK_LABEL}
  />
);
